import React from "react";
import { CModal, CModalHeader, CModalTitle, CModalBody } from "@coreui/react";
import PackageDetailsComp from "../../../components/admin/Bookings/PackgeDetailsComp";

function PackageDetails({ visible, setVisible, data }) {
     return (
          <CModal
               size="xl"
               visible={visible}
               onClose={() => setVisible(preProps => { return { ...preProps, package: false } })}
               backdrop="static"
          >
               <CModalHeader>
                    <CModalTitle> Package Details </CModalTitle>
               </CModalHeader>
               <CModalBody>
                    < PackageDetailsComp toggleModal={setVisible} data={data} />
               </CModalBody>
          </CModal>
     );
}

export default PackageDetails;